import { PostCell } from './Cells'
import { Approve, TrashTopic, MarkAsSpam } from './BulkActions'
import { createAuthorColumn, createPublishDateColumn } from './Columns'
import { getPendingContent } from './service'
/* eslint-disable import/no-internal-modules */
import Overview from '@insided/deprecated-control/overview'
import EmptyPage from '@insided/deprecated-preact-components/empty-page/EmptyPage'
import DateCell from '@insided/deprecated-control/overview/cells/DateCell'
import globals from '@insided/deprecated-utils/globals'

const PendingOverview = () => {
  function getColumns() {
    return [
      {
        header: 'Post',
        size: 'xl',
        cell: (props: any) => <PostCell {...props} />
      },
      {
        header: 'Published in',
        cell: ({ category }: { category: { name: string } }) => category?.name
      },
      createAuthorColumn(),
      { header: 'Publish date', cell: DateCell('publishedAt') }
    ]
  }

  function getBulkActions() {
    return [Approve, MarkAsSpam, TrashTopic]
  }

  return (
    <Overview
      type='pending'
      headerTitle='Pending'
      withPagination={{
        page: 1,
        pageSize: 25
      }}
      rowId='key'
      model={getColumns()}
      dataSource={getPendingContent}
      entity='posts'
      bulkActions={getBulkActions()}
      EmptyStateComponent={
        <EmptyPage
          img_src={`${globals('basePath')}images/empty_spam.png`}
          header='All done!'
          text='There are no more pending posts'
          button={{ link: '/overview', text: 'Go to content overview' }}
        />
      }
    />
  )
}

export default PendingOverview
